module.exports = __webpack_public_path__ + "images/playstore-btn.085359bb6105ed9fd7a663e05eed49a9.png";